import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { ownerContributorAndViewerIds } from 'src/components/form';
import { PageWrapper } from 'src/components/form/form/PageWrapper';
import { useInsertInternalAuditReport } from 'src/hooks/mutations/internal-audit-report';

import { internalAuditReportDetailsUrl } from '@/utils/urls';

import InternalAuditReportForm from '../../forms/internal-audit-report-form';
import type { InternalAuditReportFormDataFields } from '../../forms/internal-audit-report-form/internalAuditReportSchema';

const InternalAuditReportCreateTab: FC = () => {
  const navigate = useNavigate();
  const { insertInternalAuditReport } = useInsertInternalAuditReport();

  const onSave = async (variables: InternalAuditReportFormDataFields) => {
    const data = await insertInternalAuditReport({
      CustomAttributeData: variables.CustomAttributeData || undefined,
      ...ownerContributorAndViewerIds(variables),
      TagTypeIds: variables.tags?.map((t) => t.TagTypeId) || [],
      DepartmentTypeIds:
        variables.departments?.map((d) => d.DepartmentTypeId) || [],
      CompletedByUser: variables.CompletedByUser?.value ?? null,
      Status: variables.Status,
      StartDate: variables.StartDate,
      Title: variables.Title,
      Summary: variables.Summary,
      ActualCompletionDate: variables.ActualCompletionDate,
      NextTestDate: variables.NextTestDate,
      TargetCompletionDate: variables.TargetCompletionDate,
      Outcome: variables.Outcome,
      OriginatingItemId: null,
    });
    const result = data?.insertInternalAuditReportApi;
    if (result?.Id) {
      navigate(internalAuditReportDetailsUrl(result.Id), { replace: true });
    }

    return { savedId: result?.Id };
  };

  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(-1);
    }
  };

  return (
    <InternalAuditReportForm
      onSave={onSave}
      onDismiss={onDismiss}
      renderTemplate={(renderProps) => <PageWrapper {...renderProps} />}
    />
  );
};

export default InternalAuditReportCreateTab;
